import type { ReactElement } from 'react';
import Dialog from '../../../dialog';
import Button from '../../../button';

export type RemoveStayConfirmDialogProps = {
	isOpen: boolean;
	t: (text: string, params?: (string | number)[]) => string;
	onConfirm: () => void;
	onCancel: () => void;
};

/** Ported from `AddToCartFormModal`'s `RemoveStayAlertModal` usage, styled per the Figma "Cancellation
 * Policy" modal (title + divider + body). Shown only when `cartStore.addToCart` rejects with
 * `HAS_BOOKING_FOR_DIFFERENT_PROPERTY` / `HAS_JOURNEY_BOOKING_IN_CART`, offering to clear the existing
 * cart and retry with `forceAddToCart` - the one part of the flow that legitimately stays a real dialog
 * rather than moving inline, since it's an interrupting decision. */
export default function RemoveStayConfirmDialog({
	isOpen,
	t,
	onConfirm,
	onCancel,
}: RemoveStayConfirmDialogProps): ReactElement | null {
	return (
		<Dialog
			isOpen={isOpen}
			onClose={onCancel}
			title={<span className="text-subtitle1 text-text-heading">{t('Are You Sure?')}</span>}
			showTitle
			showCloseButton
		>
			<div className="flex max-w-[420px] flex-col gap-300 border-t border-border-subtle p-300 pt-200">
				<p className="text-body2 text-text-primary">
					{t('Your original selections will be cleared from the cart. Would you like to proceed?')}
				</p>
				<div className="flex gap-200">
					<Button intent="outline" onClick={onCancel} className="flex-1">
						{t('Cancel')}
					</Button>
					<Button intent="filled" onClick={onConfirm} className="flex-1">
						{t('Continue')}
					</Button>
				</div>
			</div>
		</Dialog>
	);
}
